import UITruncateString from 'UIComponents/text/UITruncateString';
import { View } from 'foundations-components/transitional/components/View';
import { Small } from 'foundations-components/transitional/components/Small';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTruncateString = styled.div.withConfig({
  displayName: "RevisionOptionComponent__StyledTruncateString",
  componentId: "de8kq0-0"
})(["color:", ";padding-inline:", ";padding-block:", ";"], ({
  theme
}) => theme.color['text-primary-default'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['200']);
const RevisionOptionComponent = ({
  option,
  children
}) => {
  if (option.isSpecial) {
    return children;
  }
  if (option.disabled) {
    return /*#__PURE__*/_jsx(View, {
      paddingInline: "400",
      backgroundColor: "fill-primary-disabled",
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx(Small, {
          color: "text-primary-subtle",
          children: option.text
        })
      })
    });
  }
  return (
    /*#__PURE__*/
    //@bend-expect trellis-tokenized
    _jsx(StyledTruncateString, {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: option.text
      })
    })
  );
};
export default RevisionOptionComponent;